export default "__VITE_ASSET__Ceq3ZlQs__"